import EmployeeForm from './EmployeeForm';
import common from "../../common.module.scss";
export default function EditEmployeePage() {
    return (
        <main className={common.container + " min-vh-100 d-flex justify-content-center align-items-center"}>
            <EmployeeForm />
        </main>
    );}